import { Navigate } from "react-router-dom";
import { getIsAdmin, getUserToken } from "../../../Actions/Utils";
import AdminLayout from "./AdminLayout";

export default function AdminRoute() {
  if (!getUserToken() || !getIsAdmin()) {
    console.log("getUserToken()", getUserToken());
    return <Navigate to="/" replace />;
  }
  return <AdminLayout />;
}
